
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import moment from "moment";
import Moment from "react-moment";

export default function ListCalendar() {
    const [params, setParam] = useState();
    const [filterShow, setFilterShow] = useState(false)
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (startDate > 0 && endDate > 0) _param += "&daterange=" + startDate.format('YYYY-MM-DD') + "_" + endDate.format('YYYY-MM-DD')
        setParam(_param);
    };

    const handleCallback = (start, end, label) => {
        setStartDate(start)
        setEndDate(end)
    }

    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "title", label: "Tiêu đề" },
        {
            name: "date_start", label: "Ngày bắt đầu",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let time = new Date(value);
                    return <Moment format="DD/MM/YYYY">{time}</Moment>
                },
            }
        },
        {
            name: "date_end", label: "Ngày kết thúc",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let time = new Date(value);
                    return <Moment format="DD/MM/YYYY">{time}</Moment>
                },
            }
        },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(value == 1) return "Đang hoạt động"
                    if(value == 0) return "Dừng hoạt động"
                    return null
                },
            }
        },
        { name: "author_name", label: "Người tạo" },
        { name: "datecreate", label: "Ngày tạo" },
        { name: "datemodified", label: "Ngày sửa" },
    ];

    return (<AkkhorLayout idrole="dashboard">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Văn hóa - Truyền thông
                </li>
            </ul>
        </div>
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        
                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList name="calendar" idrole="calendar" params={params} title="Văn hóa - Truyền thông" defaultLimit={50} serverSide={true} columns={columns} >
        </SRList>
    </AkkhorLayout>);
}
